import { useMemo } from 'react';

import { Address } from 'types/graphql';

import { useMutation } from '@redwoodjs/web';

import { showErrorToast } from 'src/components/Toasts/toast';
import { ADDRESS_LOOK_UP, GET_ADDRESS_DETAILS } from 'src/graphql/mutations/addressLookUp.mutation';
import { AddressList } from 'src/pages/AddMerchantPage/components/AddressInformation';

export const useAddressLookUp = () => {
    const [addressLookUp, { loading: searchingForAddress, data }] = useMutation(ADDRESS_LOOK_UP, {
        onError: () => {
            showErrorToast('Error Searching for Address');
        },
    });

    const [getAddressDetailsMutation, { loading: gettingAddressDetails }] =
        useMutation(GET_ADDRESS_DETAILS);

    const addresses: AddressList[] = useMemo(() => {
        if (data?.addressLookUp.length) {
            return data?.addressLookUp;
        }
        return [];
    }, [data]);

    // Submit handler for the search button
    const findAddress = async (value, callback?: () => void) => {
        await addressLookUp({ variables: { address: value } });
        callback && callback();
    };

    const getAddressDetails = async (
        addressId: string,
        onError?: () => void,
        onSuccess?: (data: Address[]) => void
    ) => {
        await getAddressDetailsMutation({
            variables: { addressId },
            onCompleted: ({ address }) => {
                onSuccess && onSuccess(address);
            },
            onError: () => {
                onError && onError();
                showErrorToast('Error Searching for Address');
            },
        });
    };

    return {
        searchingForAddress,
        addresses,
        findAddress,
        gettingAddressDetails,
        getAddressDetails,
    };
};
